// Basic cosine similarity function
const cosineSimilarity = (a, b) => {
  const dotProduct = a.reduce((sum, val, i) => sum + val * b[i], 0);
  const magnitudeA = Math.sqrt(a.reduce((sum, val) => sum + val * val, 0));
  const magnitudeB = Math.sqrt(b.reduce((sum, val) => sum + val * val, 0));
  return dotProduct / (magnitudeA * magnitudeB);
};

const extractDominantColors = (embedding) => {
  // MobileNetV2's early layers contain color information
  return embedding.slice(0, 64); // Adjust slice size if needed
};

const extractStyleFeatures = (embedding) => {
  // Later layers of MobileNetV2 contain style information
  return embedding.slice(-128); // Adjust slice size if needed
};

const computeHybridSimilarity = (queryEmbedding, paintingEmbedding) => {
  // Compute color similarity
  const colorSimilarity = cosineSimilarity(
    extractDominantColors(queryEmbedding),
    extractDominantColors(paintingEmbedding)
  );

  // Compute style similarity
  const styleSimilarity = cosineSimilarity(
    extractStyleFeatures(queryEmbedding),
    extractStyleFeatures(paintingEmbedding)
  );

  // Compute overall feature similarity
  const featureSimilarity = cosineSimilarity(queryEmbedding, paintingEmbedding);

  // Weighted hybrid score
  const hybridScore =
    0.4 * colorSimilarity + 0.4 * styleSimilarity + 0.2 * featureSimilarity;

  return hybridScore;
};

const adjustScore = (similarity, painting, preferences) => {
  // You can add user preference adjustments here if needed
  return similarity;
};

export const findSimilarPaintings = (
  queryEmbedding,
  paintings,
  options = {}
) => {
  const {
    minSimilarity = 0.05,
    stylePreference = null,
    colorScheme = null,
  } = options;

  // Compute similarity and score for each painting
  const results = paintings
    .map((painting) => {
      if (!Array.isArray(painting.embedding)) {
        return null;
      }
      const similarity = computeHybridSimilarity(
        queryEmbedding,
        painting.embedding
      );
      return {
        ...painting,
        similarity,
        score: adjustScore(similarity, painting, {
          stylePreference,
          colorScheme,
        }),
      };
    })
    .filter((painting) => painting && painting.similarity >= minSimilarity)
    .sort((a, b) => b.score - a.score);

  return results;
};
